export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;


export const CODE = {
    OK_CODE: 200,
    CREATED: 201,
    BAD_REQUEST_CODE: 400,
    UNAUTHORIZED_CODE: 401,
    VALIDATION_CODE: 422,
    NO_CONTENT: 204,
    INTERNAL_SERVER_ERROR: 500
}



export const SNACKBAR = {
    TIMEOUT : 2000 ,
    DIRECTION : { vertical: 'top', horizontal: 'right' } ,
    TRANSITION : { direction: 'down' }

}

export const CRUD_ACTION = {
   LIST : "list",
   ADD : "add",
   EDIT : "edit",
   DELETE : "delete",
   DETAIL : "detail",
   CLEAR : "clear",

}

export const TOAST_STATUS = {
   ON : true,
   OFF : false,
 }
 export const API_LOADING = {
  ON : true,
  OFF : false,
}

export const BID_PRICE_TYPE = {
  FIXED: 1,
  PERCENTAGE: 2,
};
 export const CRUD_STATE = {
    list: [],
    count: 0,
    detail: {},
    del: { count: 0 },
    add: { count: 0 },
    edit: { count: 0 },
    loading: false,
    status: null,
    data: null,
    error: null,
  }



 